import { ProfileAnketasTable } from './ProfileAnketasTable';

export default ProfileAnketasTable;